import React from 'react';
type PhoneFrameProps = {
  children: React.ReactNode;
  label: string;
  className?: string;
};
export function PhoneFrame({
  children,
  label,
  className = ''
}: PhoneFrameProps) {
  return <div role="img" aria-label={label} className={`w-[272px] shrink-0 rounded-[2.9rem] bg-ink p-[9px] shadow-[0_50px_100px_-30px_rgba(5,20,15,0.7)] ring-1 ring-white/10 ${className}`} data-id="element-165" data-mp="242eueg3gggdo">
      <div aria-hidden="true" className="relative h-[566px] overflow-hidden rounded-[2.4rem] bg-canvas text-ink" data-id="element-166" data-mp="1v2id4zjeajsn">
        <div className="absolute left-1/2 top-2 z-30 h-[22px] w-[88px] -translate-x-1/2 rounded-full bg-ink" data-id="element-167" data-mp="1q2471n1ctjx9" />
        {children}
      </div>
    </div>;
}